import { UploadedFile } from "@/shared/types/file-upload";
import { EvidenceDocument } from "../../requests";
import EvidenceDocumentCard from "./EvidenceDocumentCard";

interface DocumentUploadGridProps {
  evidenceDocuments: EvidenceDocument[];
  documentFiles: Record<string, UploadedFile[]>;
  onDocumentFilesChange: (documentId: string, files: UploadedFile[]) => void;
  onUploadError: (documentId: string, hasError: boolean) => void;
  savingStates: Record<string, boolean>;
  customDeleteHandler?: (signedUrl: string, fileId: string) => Promise<void>;
}

const DocumentUploadGrid: React.FC<DocumentUploadGridProps> = ({
  evidenceDocuments,
  documentFiles,
  onDocumentFilesChange,
  onUploadError,
  savingStates,
  customDeleteHandler,
}) => {
  if (!evidenceDocuments || evidenceDocuments.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        <p>No documents required for this assessment.</p>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center">
      {/* Grid container - 2 columns with proper spacing matching design */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 auto-rows-fr max-w-6xl w-full">
        {evidenceDocuments.map((document) => (
          <EvidenceDocumentCard
            key={document.id}
            document={document}
            files={documentFiles[document.id] || []}
            onFilesChange={onDocumentFilesChange}
            onUploadError={onUploadError}
            isSaving={savingStates[document.id] || false}
            customDeleteHandler={customDeleteHandler}
          />
        ))}
      </div>
    </div>
  );
};

export default DocumentUploadGrid;